// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// `localStorage` so existe no navegador. Durante a geracao estatica este
// modulo e importado no Node (todo Header puxa useTrackEvent, que puxa daqui),
// e referenciar o identificador solto derrubava o build inteiro com
// ReferenceError -- antes mesmo de qualquer render. No servidor a sessao nao
// precisa persistir: nao ha usuario logado durante o build.
const noBrowser = typeof window === 'undefined';

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: noBrowser ? undefined : localStorage,
    persistSession: !noBrowser,
    autoRefreshToken: !noBrowser,
  }
});